export const dummyItems = [
  {
    time: "12:39",
    title:
      "The Fly: TD Synnex price target raised to $160 from $150 at Loop Capital",
  },
  {
    time: "12:38",
    title:
      "CGTNEurope: IRAN MINISTRY OF ROADS AND URBAN DEVELOPMENT SPOKESPERSON SAYS IRAN'S WESTERN AND CENTRAL AIRSPACE IS OPEN ONLY TO INTERNATIONAL TRANSIT FLIGHTS - TASMIN",
  },
  {
    time: "12:38",
    title:
      "The Fly: Pegasystems price target raised to $60 from $52.50 at Loop Capital",
  },
  {
    time: "12:37",
    title:
      "Benzinga News: Sonim Technologies Issues Update On Proposed Reverse Takeover With Nvidia-Based High-Performance Computing AI Factories",
  },
  {
    time: "12:37",
    title:
      "Benzinga News: SunCar Technology Expands Strategic Partnership With Xiaomi To Power Fully Intelligent Auto Insurance For YU7",
  },
  {
    time: "12:37",
    title:
      "The Fly: Seaport starts Chime with a Buy, sees 'right recipe' for growth",
  },
  {
    time: "12:36",
    title:
      "The Fly: Diginex announces more government funding support for compliance solutions",
  },
  {
    time: "12:36",
    title:
      "Benzinga News: Abeona Therapeutics Added To Russell 2000 And Russell 3000 Indexes Following ZEVASKYN FDA Approval",
  },
  {
    time: "12:36",
    title:
      "Benzinga News: BridgeBio Sells Portion Of Royalties From BEYONTRA Sales In Europe To Blue Owl Capital For $300M",
  },
  {
    time: "12:38",
    title:
      "The Fly: Pegasystems price target raised to $60 from $52.50 at Loop Capital",
  },
  {
    time: "12:37",
    title:
      "Benzinga News: Sonim Technologies Issues Update On Proposed Reverse Takeover With Nvidia-Based High-Performance Computing AI Factories",
  },
  {
    time: "12:37",
    title:
      "Benzinga News: SunCar Technology Expands Strategic Partnership With Xiaomi To Power Fully Intelligent Auto Insurance For YU7",
  },
  {
    time: "12:37",
    title:
      "The Fly: Seaport starts Chime with a Buy, sees 'right recipe' for growth",
  },
  {
    time: "12:36",
    title:
      "The Fly: Diginex announces more government funding support for compliance solutions",
  },
  {
    time: "12:36",
    title:
      "Benzinga News: Abeona Therapeutics Added To Russell 2000 And Russell 3000 Indexes Following ZEVASKYN FDA Approval",
  },
  {
    time: "12:36",
    title:
      "Benzinga News: BridgeBio Sells Portion Of Royalties From BEYONTRA Sales In Europe To Blue Owl Capital For $300M",
  },
  {
    time: "12:39",
    title:
      "The Fly: TD Synnex price target raised to $160 from $150 at Loop Capital",
  },
  {
    time: "12:38",
    title:
      "CGTNEurope: IRAN MINISTRY OF ROADS AND URBAN DEVELOPMENT SPOKESPERSON SAYS IRAN'S WESTERN AND CENTRAL AIRSPACE IS OPEN ONLY TO INTERNATIONAL TRANSIT FLIGHTS - TASMIN",
  },
  {
    time: "12:38",
    title:
      "The Fly: Pegasystems price target raised to $60 from $52.50 at Loop Capital",
  },
  {
    time: "12:37",
    title:
      "Benzinga News: Sonim Technologies Issues Update On Proposed Reverse Takeover With Nvidia-Based High-Performance Computing AI Factories",
  },
  {
    time: "12:37",
    title:
      "Benzinga News: SunCar Technology Expands Strategic Partnership With Xiaomi To Power Fully Intelligent Auto Insurance For YU7",
  },
  {
    time: "12:37",
    title:
      "The Fly: Seaport starts Chime with a Buy, sees 'right recipe' for growth",
  },
  {
    time: "12:36",
    title:
      "The Fly: Diginex announces more government funding support for compliance solutions",
  },
  {
    time: "12:36",
    title:
      "Benzinga News: Abeona Therapeutics Added To Russell 2000 And Russell 3000 Indexes Following ZEVASKYN FDA Approval",
  },
  {
    time: "12:36",
    title:
      "Benzinga News: BridgeBio Sells Portion Of Royalties From BEYONTRA Sales In Europe To Blue Owl Capital For $300M",
  },
  {
    time: "12:38",
    title:
      "The Fly: Pegasystems price target raised to $60 from $52.50 at Loop Capital",
  },
  {
    time: "12:37",
    title:
      "Benzinga News: Sonim Technologies Issues Update On Proposed Reverse Takeover With Nvidia-Based High-Performance Computing AI Factories",
  },
  {
    time: "12:37",
    title:
      "Benzinga News: SunCar Technology Expands Strategic Partnership With Xiaomi To Power Fully Intelligent Auto Insurance For YU7",
  },
  {
    time: "12:37",
    title:
      "The Fly: Seaport starts Chime with a Buy, sees 'right recipe' for growth",
  },
  {
    time: "12:36",
    title:
      "The Fly: Diginex announces more government funding support for compliance solutions",
  },
  {
    time: "12:36",
    title:
      "Benzinga News: Abeona Therapeutics Added To Russell 2000 And Russell 3000 Indexes Following ZEVASKYN FDA Approval",
  },
  {
    time: "12:36",
    title:
      "Benzinga News: BridgeBio Sells Portion Of Royalties From BEYONTRA Sales In Europe To Blue Owl Capital For $300M",
  },
];
